import { Grid } from '@mui/material';

const FieldWrapper = ({ cols, children }) => (
  <Grid item xs={16 / cols} style={{ paddingTop: 0 }}>
    {children}
  </Grid>
);
export default FieldWrapper;